module.exports = __webpack_public_path__ + "static/img/myntra_test.5197a590.png";